import styled from '@emotion/styled';

export const ESplayCorner = styled.span`
  position: absolute;
  top: -2px; // This negative value is needed to create a cutted corner
  right: -2px; // This negative value is needed to create a cutted corner
  width: 0;
  height: 0;
  border: 10px solid var(--color-core-white);
  border-left-color: transparent;
  border-bottom-color: transparent;
  pointer-events: none;

  :after {
    content: '';
    position: absolute;
    top: -4px; // This negative value is needed to create a cutted corner
    right: -4px; // This negative value is needed to create a cutted corner
    width: 24px;
    height: 24px;
    transform: rotate(45deg);
    border-top: var(--regular-border-width) solid var(--color-box-border);
  }
`;
